import DetailEpisodeListGraphQL from './DetailEpisodeList'

export default DetailEpisodeListGraphQL
// eslint-disable-next-line import/export
export * from './DetailEpisodeList'
